// ---------- helpers ----------
const clone = (v) => JSON.parse(JSON.stringify(v ?? {}));

export function ensureShape(model = {}) {
  const c = clone(model);

  // Core fields
  c.id = c.id ?? null;
  c.name = c.name ?? "";
  c.regionOfOrigin = c.regionOfOrigin ?? "";
  c.linkPage = c.linkPage ?? "";

  // Validations
  c.validations = c.validations || {
    name: "",
    regionOfOrigin: "",
    linkPage: "",
  };
  c.validations.name = c.validations.name ?? "";
  c.validations.regionOfOrigin = c.validations.regionOfOrigin ?? "";
  c.validations.linkPage = c.validations.linkPage ?? "";

  return c;
}

export function formatToSend(data = {}) {
  const editMode = !!data.id;
  const out = {
    id: data.id ?? null,
    name: (data.name || "").trim(),
    regionOfOrigin: data.regionOfOrigin || "",
    linkPage: (data.linkPage || "").trim(),
  };
  return [out, editMode];
}

export function parseFromApi(api = {}) {
  const platform = api.platformScienceSource || api;
  return {
    id: platform.id ?? null,
    name: platform.name ?? "",
    regionOfOrigin: platform.region_of_origin ?? "",
    linkPage: platform.link_page ?? "",
    validations: { name: "", regionOfOrigin: "", linkPage: "" },
  };
}

export function validatePlatform(model, { t = (k) => k } = {}) {
  model.validations = { name: "", regionOfOrigin: "", linkPage: "" };
  let isValid = true;

  if (!model.name || !model.name.trim()) {
    model.validations.name = t("views.science_source_platforms.validation.name") || "Name is required";
    isValid = false;
  }

  if (!model.regionOfOrigin) {
    model.validations.regionOfOrigin =
      t("views.science_source_platforms.validation.region") || "Region of origin is required";
    isValid = false;
  }

  if (!model.linkPage || !model.linkPage.trim()) {
    model.validations.linkPage = t("views.science_source_platforms.validation.link") || "Link is required";
    isValid = false;
  } else {
    const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/;
    if (!urlPattern.test(model.linkPage.trim())) {
      model.validations.linkPage = t("views.science_source_platforms.validation.link_invalid") || "Invalid URL";
      isValid = false;
    }
  }

  return isValid;
}
